import { motion } from "framer-motion";
import { educationData } from "../lib/ui";

export default function Education() {
  return (
    <div className="relative pl-6 sm:pl-8 border-l border-app-border py-2">
      {/* Glow Line (behind the border) */}
      <div className="absolute top-0 bottom-0 left-[-1px] w-[2px] bg-gradient-to-b from-app-accent via-app-secondary to-transparent opacity-50" />

      <div className="space-y-10">
        {educationData.map((edu, i) => {
          const isOngoing = edu.status === "ongoing";
          return (
            <motion.div
              key={i}
              className="relative group"
              initial={{ opacity: 0, x: -15 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              {/* Timeline Node */}
              <div className="absolute -left-[33px] sm:-left-[41px] top-1 flex items-center justify-center">
                {isOngoing ? (
                  <div className="relative flex items-center justify-center w-5 h-5">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-app-accent opacity-40 animate-pulse-glow" />
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-app-accent shadow-glow" />
                  </div>
                ) : (
                  <div className="w-5 h-5 rounded-full border-[3px] border-app-border bg-app-soft shadow-sm transition-colors duration-300 group-hover:bg-app-secondary group-hover:border-app-secondary" />
                )}
              </div>

              {/* Content Card */}
              <div className="bg-app-panel/40 border border-app-border/60 rounded-2xl p-5 hover:bg-app-panel hover:shadow-glow transition-all duration-300 group-hover:-translate-y-1 group-hover:border-app-accent backdrop-blur-sm">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-1.5">
                  <h4 className="font-display font-bold text-app-text text-sm sm:text-base leading-tight">
                    {edu.degree}
                  </h4>
                  {isOngoing && (
                    <span className="px-2 py-0.5 rounded-full text-[9px] font-bold tracking-wider uppercase bg-app-accent/20 text-app-accent">
                      Current
                    </span>
                  )}
                </div>

                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-medium text-app-mute mb-3">
                  <span className="text-app-accent">{edu.institution}</span>
                  <span className="w-1 h-1 rounded-full bg-app-border" />
                  <span className="font-mono text-[11px] text-app-dim">{edu.year}</span>
                </div>

                <p className="text-xs text-app-mute leading-relaxed">
                  {edu.details}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
